/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */


import { OktaAuth, SigninOptions } from '@okta/okta-auth-js';
import config from '../config';

export const OktaClient = new OktaAuth({
  issuer: config.okta.issuer,
  clientId: config.okta.clientId,
  redirectUri: window.location.origin + '/login/callback'
})

export const authWithCredentials = async (opts: SigninOptions) => {
  const { sessionToken } = await OktaClient.signIn(opts)
  // Exchange session for access token
  const { tokens } = await OktaClient.token.getWithoutPrompt({ sessionToken });
  return OktaClient.tokenManager.setTokens(tokens);
}
